
































import { Component, Vue, Prop } from "vue-property-decorator";
import IconComponent from "../icons/icon-component.vue";
import type { SICON } from "@/@types/_shared/src.js";

@Component({ components: { IconComponent } })
class BSwitch extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly value!: boolean;

  @Prop({ type: String, default: "flexSwitchCheckDefault" })
  readonly id!: string;

  @Prop({ type: String, default: "" })
  readonly title!: string;

  @Prop({ type: Object, default: null })
  readonly icon!: SICON;

  handleChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.$emit("input", checked);
  }
}
export default BSwitch;
